import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRODUCT_NAME } from '../data/content';
export function Hero() {
  return <header className="bg-navy" data-id="element-87" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-3xl px-4 pb-5 pt-4 text-center sm:pt-7" data-id="element-88" data-mp="9k0f38zo2hq6">
        <p className="font-display text-xs font-extrabold tracking-wide text-energy sm:text-sm" data-id="element-89" data-mp="4lyvmmybwge6">
          ⚡ MÉTODO DOCENTE PASO A PASO
        </p>
        <h1 className="mt-1.5 font-display text-[1.6rem] font-black leading-[1.1] text-white sm:text-5xl" data-id="element-90" data-mp="128yy08bm5nwj">
          El sistema completo para preparar y enseñar electricidad técnica{' '}
          <span className="text-energy" data-id="element-91" data-mp="sa9n4zi4x3ps">sin empezar de cero cada semana</span>
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-snug text-white/80 sm:text-base" data-id="element-92" data-mp="nb6k1klpt7kg">
          Organiza tus clases, prácticas, evaluaciones y proyectos con un sistema pensado para profesores de
          electricidad, y recupera horas de preparación — sin perderte creando materiales, ejercicios, exámenes y
          actividades desde cero.
        </p>

        <p className="mt-3 rounded-md bg-electric px-3 py-2 font-display text-[0.72rem] font-extrabold leading-tight text-white sm:text-sm" data-id="element-93" data-mp="3o7lq5lizewmb">
          ⚡ {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </p>

        <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto mt-2 block max-w-xl transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.99]" data-id="element-94" data-mp="3e9fuvmrokoqf">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-95" data-mp="359sxrd5zi536" />
        </a>

        <CtaBlock onDark note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-96" data-mp="2qkwk90l5rzv6" />
      </div>
    </header>;
}